
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gf8NwgFWJM8W6ijT19ow9Zy5zUj4TuAbar6m378D46AgMeta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexQWzxv_2TrCGzH5g7nCKcsKobUwVBtaeO1REds8W3essMeta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchXbNwmqUdv_WGeti0MihDqN6Q7rzBpwrX0A8NNKSvlSEMeta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexFVo7yTuCe3qnZlFUYLIlItXe61cno3xXsnimv4wKLa8Meta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93tEFYUkj5XzURM1mNgqZdb1sDhOEHlAPsTrKaJ_EHFQEMeta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexvaPK4t2yP0mrHF2orFFhWseyrTdTrJQxNe1EgDGmfv0Meta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Obwt0LSvcUengcIO0S_WkgTJtxMx2_fjR0X0_MD79skMeta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexpIeFt5drpgPiejYgO9ZvXE8fJomWc9M3YH1EgsBAsCkMeta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93Sa8JkgVX4YqsNo1jWOhKWN_45LIEJeHxv4Ybdm2DAimBQMeta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index3IIIkL5phzJm7NiUi_451ynmD3EPY57Q1HBn3v0n_45zw34Meta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index0LX6uzp2brYjVA5_8Dyj22I_3usHw9aO1f5oAuqZAN4Meta } from "/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexvaPK4t2yP0mrHF2orFFhWseyrTdTrJQxNe1EgDGmfv0Meta || {},
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexpIeFt5drpgPiejYgO9ZvXE8fJomWc9M3YH1EgsBAsCkMeta || {},
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index3IIIkL5phzJm7NiUi_451ynmD3EPY57Q1HBn3v0n_45zw34Meta || {},
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index0LX6uzp2brYjVA5_8Dyj22I_3usHw9aO1f5oAuqZAN4Meta || {},
    component: () => import("/codebuild/output/src2452981296/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]